import { withStyles } from '@material-ui/core';

const styles = (theme) => ({
  label: {
    color: theme.gridTextColor,
    fontSize: theme.textFontSize,
    fontWeight: 500
  },
  upperCase: {
    textTransform: 'uppercase'
  }
});
const Label = ({ labelText, upperCase = true, classes }) => (
  <div className={`${classes.label} ${upperCase ? classes.upperCase : ''}`}>{labelText}</div>
);

export default withStyles(styles)(Label);
